module.exports = __webpack_public_path__ + "static/media/respcamp.eb715071.png";